'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.SystemStatus.CommonServices', []).factory('SystemStatusCommonRendererFactory', require('./services/SystemStatusCommonRendererFactory'));